import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

function countdown(secondsLeft: number): string {
    const minutes = Math.floor(secondsLeft / 60)
    const seconds = secondsLeft % 60
    return `${minutes}:${String(seconds).padStart(2, '0')}`
}

/**
 * Shown for the last few minutes of an idle session. It is modal on purpose: the alternative to
 * noticing this is being thrown back to the login screen with a half-filled form, and getting
 * back in means a round trip through Visma.
 *
 * There is no "close" — dismissing it would leave the countdown running invisibly, which is the
 * situation the warning exists to prevent. Staying is one click, and so is leaving.
 */
export default function SessionExpiryDialog({ secondsLeft, busy, onStay, onLogOut }: {
    secondsLeft: number,
    busy: boolean,
    onStay: () => void,
    onLogOut: () => void,
}) {
    return (
        <Dialog open={true}>
            <DialogTitle>Du loggas ut snart</DialogTitle>
            <DialogContent>
                <DialogContentText component="div">
                    <p>
                        Du har varit inaktiv en längre stund. Om ingenting händer loggas du ut
                        om <strong>{countdown(secondsLeft)}</strong>.
                    </p>
                    <p>
                        Sparade utkast finns kvar, men uppgifter du håller på att fylla i går
                        förlorade. Att logga in igen sker via Visma.
                    </p>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onLogOut} disabled={busy}>Logga ut nu</Button>
                <Button onClick={onStay} disabled={busy} variant="contained" autoFocus>
                    {busy ? <CircularProgress size="1em"/> : 'Stanna kvar'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
